async function getPosts(param) {
  const response = await fetch(
    process.env.REACT_APP_WWW_URL + '/wp-json/wp/v2/posts' + param
  );
  return await response.json();
}

export default getPosts;
